<div class="app-container">
  <app-header></app-header>

  <main class="main-content">
    <router-outlet></router-outlet>
  </main>

  <app-footer></app-footer>

  <!-- Menú lateral móvil -->
  <app-mobile-menu></app-mobile-menu>
</div>
